import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Header, Grid, Dimmer, Loader, Message, Button, Card, List } from 'semantic-ui-react';
import _ from 'underscore';

import {
    submitSystemAdminUserVerifyBankAccount,
    getSystemAdminUsers,
} from '../../actions';

class VerifyUserBank extends Component {
    state = {
        isLoading: false,
        currentPage: 1,
        perPage: 50,
        users: [],
    }

    componentWillMount() {
        if (!this.props.user.roles.find(r => r.type === 'ADMIN_ACCOUNT')) {
            this.props.history.replace("/");
        }
    }

    componentWillUpdate() {
        if (!this.props.user.roles.find(r => r.type === 'ADMIN_ACCOUNT')) {
            this.props.history.replace("/");
        }
    }

    componentDidMount() {
        this.getUsers()
    }

    getUsers = () => {
        const { accessToken } = this.props.user;

        this.setState({ isLoading: true }, () => {
            this.props.getSystemAdminUsers({
                accessToken,
                searchPage: this.state.currentPage,
                searchMax: this.state.perPage,
                params: {
                    proposedBankStatus: 'WAITING_VERIFICATION'
                }
            }, (result, error) => {
                if (result) {
                    this.setState({ users: result.data.users })
                }
                this.setState({ isLoading: false })
            });
        });
    }

    approveBank = (uuid) => {
        this.setState({ isLoading: true }, () => {
            this.props.submitSystemAdminUserVerifyBankAccount({
                accessToken: this.props.user.accessToken,
                data: {
                    userId: uuid,
                    status: 'APPROVED',
                    note: null
                }
            }, () => {
                this.setState({ isLoading: false })
                this.getUsers()
            })
        })
    }

    declineBank = (uuid) => {
        this.setState({ isLoading: true }, () => {
            this.props.submitSystemAdminUserVerifyBankAccount({
                accessToken: this.props.user.accessToken,
                data: {
                    userId: uuid,
                    status: 'REJECTED',
                    note: null
                }
            }, () => {
                this.setState({ isLoading: false })
                this.getUsers()
            })
        })
    }

    render() {
        return (
            <Container>
                <Grid columns="equal">
                    <Grid.Column width={16}>
                        <Header as="h2" textAlign="center">
                            Verify Users Bank Account
                        </Header>
                    </Grid.Column>
                </Grid>
                <Dimmer.Dimmable>
                    <Dimmer active={this.state.isLoading} inverted>
                        <Loader />
                    </Dimmer>
                    {
                        this.state.users.length === 0 ?
                            <Message info>No user data.</Message>
                            :
                            <Card.Group>
                                {
                                    _.map(this.state.users, (user) => {
                                        const {
                                            uuid,
                                            nric,
                                            name,
                                            proposedBankDetail
                                        } = user;
                                        return (
                                            <Card key={uuid}>
                                                <Card.Content>
                                                    <Card.Header>{name}</Card.Header>
                                                    <Card.Meta>{nric}</Card.Meta>
                                                </Card.Content>
                                                <Card.Content>
                                                    <Card.Description>
                                                        <List>
                                                            <List.Item>
                                                                <List.Header>Bank Name</List.Header>
                                                                <List.Description>{proposedBankDetail.bankName}</List.Description>
                                                            </List.Item>
                                                            <List.Item>
                                                                <List.Header>Bank No</List.Header>
                                                                <List.Description>{proposedBankDetail.bankNo}</List.Description>
                                                            </List.Item>
                                                            <List.Item>
                                                                <List.Header>Branch No</List.Header>
                                                                <List.Description>{proposedBankDetail.branchNo}</List.Description>
                                                            </List.Item>
                                                            <List.Item>
                                                                <List.Header>Account No</List.Header>
                                                                <List.Description>{proposedBankDetail.accountNo}</List.Description>
                                                            </List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                                <Card.Content extra>
                                                    <div className='ui two buttons'>
                                                        <Button basic color='red' onClick={() => this.declineBank(uuid)}>Decline</Button>
                                                        <Button color='green' onClick={() => this.approveBank(uuid)}>Approve</Button>
                                                    </div>
                                                </Card.Content>
                                            </Card>
                                        );
                                    })
                                }
                            </Card.Group>
                    }
                </Dimmer.Dimmable>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user
    }
}

export default connect(mapStateToProps, {
    submitSystemAdminUserVerifyBankAccount,
    getSystemAdminUsers,
})(VerifyUserBank);